(function() {
  var BaseHandler, DetailOutput,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseHandler = App.loadClass("core::reports/BaseHandler");

  DetailOutput = App.loadClass("core::reports/DetailOutput");

  exports.Audit_SubHandler = (function(superClass) {
    extend(Audit_SubHandler, superClass);

    function Audit_SubHandler() {
      return Audit_SubHandler.__super__.constructor.apply(this, arguments);
    }

    Audit_SubHandler.prototype.init = function(data) {
      var opt;
      this.layoutUrl = 'backend/portal/audit/table';
      this.excelUrl = 'backend/portal/audit/excel';
      this.filterUrl = 'backend/portal/audit/filters';
      this.saveUrl = 'backend/portal/audit/save';
      this.layoutSelector = '#audit_container';
      this.refreshNavHandler = false;
      this.subHandlers = {
        'View_Audit_Breadcrumb': {
          'class': 'portal::handlers/audit/View_Audit_Breadcrumb'
        }
      };
      this.defaultSub = 'View_Audit_Breadcrumb';
      this.currentOutput = new DetailOutput(this, this.parent, 800, {
        sAjaxSource: 'backend/portal/audit/output/detail'
      });
      opt = {
        "changed_by": {
          opt: {
            key: data.data.users_id,
            value: data.data.user
          }
        }
      };
      return this.setDefaultsAndRun(0, 5, 15, opt);
    };

    Audit_SubHandler.prototype.afterLoadLayout = function(selector, response) {
      Audit_SubHandler.__super__.afterLoadLayout.call(this);
      $(this.layoutSelector).off(".chk-update");
      $(this.layoutSelector).on("click.chk-update", ".chk-update", (function(_this) {
        return function(e) {
          var saveData;
          saveData = {
            'toUpdate': {
              'at_id': $(e.target).attr('id')
            }
          };
          return $.post(_this.saveUrl, saveData);
        };
      })(this));
      $(this.layoutSelector).off(".summary");
      return $(this.layoutSelector).on("click.summary", ".summary, i", (function(_this) {
        return function(e) {
          var handler, id;
          id = $(e.target).closest('div').attr('data-at-id');
          handler = _this.createSubHandler(_this.defaultSub);
          if (handler) {
            return handler.init(id);
          }
        };
      })(this));
    };

    Audit_SubHandler.prototype.refreshReport = function() {
      var opt;
      if ($.contains(document, this.parent.msg[0]) && this.parent.msg.length !== 0) {
        this.parent.msg.message_writer('info', 'Running Report...');
      }
      this.filters = ko.toJSON(this.parent.filters.jsonize());
      opt = {
        postOptions: {
          query: this.filters
        }
      };
      return this.loadLayout(opt);
    };

    return Audit_SubHandler;

  })(BaseHandler);

}).call(this);
